import styled, { css } from "styled-components"

const NavButtonStyle = css`
  background: ${(p) => p.theme.colors.card.default};
  height: 11rem;
  width: 11rem;
  border-radius: 100%;
  pointer-events: all;
  display: flex;
  align-items: center;
  transition: all 0.3s ease-in-out;
  position: absolute;
  cursor: pointer;

  &:hover {
    background: ${(p) => p.theme.colors.card.active};
  }

  svg {
    height: 1.5rem;
    transition: all 0.3s ease-in-out;
    width: 1.5rem;
    fill: ${(p) => p.theme.colors.text.light};
  }
`

export const NextContainer = styled.div`
  ${NavButtonStyle};
  top: calc(50% - 5.5rem);
  right: 0;
  transform: translateX(8rem);
  z-index: 10;
  &:hover {
    transform: translateX(7.5rem);

    svg {
      margin-left: 1.25rem;
    }
  }

  svg {
    margin-left: 1rem;
  }
`

export const PrevContainer = styled.div`
  ${NavButtonStyle};
  transform: translateX(-8rem);
  justify-content: flex-end;
  top: calc(50% - 5.5rem);
  left: 0;
  &:hover {
    transform: translateX(-7.5rem);

    svg {
      margin-right: 1.25rem;
    }
  }

  svg {
    margin-right: 1rem;
  }
`
